import(/* webpackMode: "eager", webpackExports: ["AllPricesSection"] */ "/vercel/path0/app/(global)/tarifs/AllPricesSection.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/assets/images/CTA-backgroung.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["Breadcrumb"] */ "/vercel/path0/app/components/sections/Breadcrumb.tsx");
